import { render } from "./TabContainer.vue?vue&type=template&id=4c876c0f&scoped=true&ts=true"
import script from "./TabContainer.vue?vue&type=script&lang=ts"
export * from "./TabContainer.vue?vue&type=script&lang=ts"

import "./TabContainer.vue?vue&type=style&index=0&id=4c876c0f&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c876c0f"]])

export default __exports__